<div class="data-access-root">
  <div class="toolbar">
    <div class="type-select">
      <label>Type:</label>
      <mat-select [(value)]="selectedType">
        <mat-option *ngFor="let t of objectTypes" [value]="t">{{t}}</mat-option>
      </mat-select>
    </div>

    <div class="actions">
      <button mat-stroked-button (click)="setView()">View</button>
      <button mat-stroked-button (click)="setSearch()">Search</button>
      <button mat-stroked-button (click)="setEdit()">Edit</button>
      <button mat-stroked-button color="primary" (click)="addNew()">Add New</button>
      <button mat-stroked-button color="accent" (click)="updateSelected()">Update</button>
      <button mat-stroked-button color="warn" (click)="deleteSelected()">Delete</button>
    </div>
  </div>

  <div class="split">
    <div class="top">
      <!-- search UI --- shown in search mode -->
      <div *ngIf="mode === 'search'" class="search-box-grid">
        <div class="search-row">
          <mat-form-field appearance="outline">
            <mat-label>ID</mat-label>
            <input matInput [(ngModel)]="searchModel.ID" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Code</mat-label>
            <input matInput [(ngModel)]="searchModel.Code" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Description</mat-label>
            <input matInput [(ngModel)]="searchModel.Description" />
          </mat-form-field>
        </div>

        <div class="search-row">
          <app-supplier-object-lookup label="Supplier" [id]="searchModel.Supplier" (idChange)="searchModel.Supplier = $any($event)"></app-supplier-object-lookup>
          <app-country-object-lookup label="Country" [id]="searchModel.CountryOfOrigin" (idChange)="searchModel.CountryOfOrigin = $any($event)"></app-country-object-lookup>
          <app-hscode-object-lookup label="HSCode" [id]="searchModel.HSCode" (idChange)="searchModel.HSCode = $any($event)"></app-hscode-object-lookup>
        </div>

        <div class="search-row">
          <mat-form-field appearance="outline">
            <mat-label>Unit</mat-label>
            <input matInput [(ngModel)]="searchModel.Unit" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>CatName</mat-label>
            <input matInput [(ngModel)]="searchModel.CatName" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Currency</mat-label>
            <input matInput [(ngModel)]="searchModel.Currency" />
          </mat-form-field>
        </div>

        <div class="search-actions">
          <button mat-flat-button color="primary" (click)="doSearch()">Search</button>
          <button mat-stroked-button (click)="searchModel = {}">Clear</button>
        </div>
      </div>

      <!-- view/edit UI --- shown in top half when viewing or editing -->
      <div *ngIf="mode !== 'search'" class="editor-top">
        <ng-container *ngIf="selectedType==='Product'">
          <app-data-access-products [id]="selectedId" [mode]="mode"></app-data-access-products>
        </ng-container>
      </div>
    </div>

    <!-- results list shown in bottom half regardless of mode -->
    <div class="bottom">
      <div class="results-list">
        <table class="results-grid" *ngIf="resultColumns.length > 0">
          <thead>
            <tr>
              <th *ngFor="let c of resultColumns">{{ headerLabel(c) }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let r of results" (click)="selectResult(r)">
              <td *ngFor="let c of resultColumns">{{ r[c] ?? r[c.toLowerCase()] ?? r[c.charAt(0).toLowerCase() + c.slice(1)] }}</td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="resultColumns.length === 0" class="no-results">No results</div>
      </div>
    </div>
  </div>
</div>
